import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { AmountFormat } from '../../Format/AmountFormat';

export type SummaryLineProps = {
  sumTotalVatAmount?: number;
  sumTotalExcludingVat?: number;
  sumAmountToPay?: number;
  currencyCode?: string;
};

const SummaryLine = ({ sumTotalVatAmount, sumTotalExcludingVat, sumAmountToPay, currencyCode }: SummaryLineProps) => {
  return (
    <TableRow>
      <TableCell />
      <TableCell>{sumTotalVatAmount && <AmountFormat amount={sumTotalVatAmount} />}</TableCell>
      <TableCell>{sumTotalExcludingVat && <AmountFormat amount={sumTotalExcludingVat} />}</TableCell>
      <TableCell>{sumAmountToPay && <AmountFormat amount={sumAmountToPay} currencyCode={currencyCode} />}</TableCell>
    </TableRow>
  );
};

export type VatSummaryLineProps = {
  vatPercentage?: string;
  vatBasis?: number;
  vatAmount?: number;
};

const VatSummaryLine = ({ vatPercentage, vatBasis, vatAmount }: VatSummaryLineProps) => {
  return (
    <TableRow>
      <TableCell />
      <TableCell>{vatPercentage && <AmountFormat amount={+vatPercentage} />}</TableCell>
      <TableCell>{vatBasis && <AmountFormat amount={vatBasis} />}</TableCell>
      <TableCell>{vatAmount && <AmountFormat amount={vatAmount} />}</TableCell>
    </TableRow>
  );
};

export { SummaryLine, VatSummaryLine };
